import { Record } from 'immutable';
import {ReduceStore} from 'flux/utils';
import ActionTypes from '../ActionTypes';
import AppDispatcher from '../AppDispatcher';

const State = new Record({
    username: '',
    password: '',
    executingLogin: false,
    lastMenu: null,
});

class LoginStore extends ReduceStore {
    constructor() {
        super(AppDispatcher);
    }

    getInitialState() {
        return new State();
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.START:
                if (!action.user) return state;
                return state.set('username', action.user.username);

            case ActionTypes.LOGIN_START:
                return state.set('executingLogin', true);

            case ActionTypes.LOGIN_FINISH:
            case ActionTypes.LOGIN_FAILED:
                return state.set('password', '').set('executingLogin', false);

            case ActionTypes.UPDATE_TOKEN_FAILED:
            case ActionTypes.LOGOUT:
                return state.set('password', '').set('executingLogin', false).set('lastMenu', null);

            case ActionTypes.UPDATE_TEXT:
                if (action.field !== 'username' && action.field !== 'password') return state;
                return action.field === 'username' ?
                    state.set('username', action.value) :
                    state.set('password', action.value);

            case ActionTypes.CHOOSE_MENU_START:
                return state.set('lastMenu', action.menu);

            default:
                return state;
        }
    }
}

export default new LoginStore();



// WEBPACK FOOTER //
// src/stores/LoginStore.js